import { Suspense, useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Button } from '@iwoca/orion';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { ErrorBoundary } from '../../../../../errorBoundary/ErrorBoundary';
import { GET_REPAYMENT_SCHEDULE } from '../../../../drawDown/DrawDown.actions';
import { buildLocationWithSearch } from '../../../../drawDown/DrawDownHelper';
import FallbackErrorModal from '../../../../modals/fallbackErrorModal/FallbackErrorModal';
import MainContentPending from '../../../../pageStructure/mainContentPending';
import RepaymentScheduleSummary from '../../../dashboardComponents/repaymentScheduleSummary/RepaymentScheduleSummary';
import { useGetDrawdownActionPanelData } from '../../../dashboardWidgets/drawdownActionPanel/useGetDrawdownActionPanelData';
import styles from '../DashboardActionPanel.module.css';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    continueToDrawdown: (amount: number, offerId: string) => {
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            //@ts-ignore
            location: buildLocationWithSearch({
                pathname: '/funding-requirements/',
                offerId: offerId,
                amount: amount
            })
        });
    },
    getRepaymentSchedule: (
        amount: number,
        offerId: string,
        productType: string
    ) => {
        dispatch({
            type: GET_REPAYMENT_SCHEDULE,
            amount,
            offerId,
            productType
        });
    }
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

export const InterestOnlyExtend = connect(
    null,
    mapDispatchToProps
)(({
    getRepaymentSchedule,
    continueToDrawdown,
    accountId
}: { accountId: string } & PropsFromRedux) => {
    const { drawdownOffer } = useGetDrawdownActionPanelData(accountId);

    useEffect(() => {
        if (drawdownOffer)
            getRepaymentSchedule(
                0,
                drawdownOffer.offer_id!,
                drawdownOffer.product_type!
            );
    }, [getRepaymentSchedule, drawdownOffer, drawdownOffer?.product_type]);

    return (
        <div className={styles.drawdownContainer}>
            <Button
                data-testid="continue-to-drawdown-button"
                className={styles.drawdownCTA}
                variant="success"
                disabled={!drawdownOffer}
                onClick={() => {
                    tracking.ampli.drawdownCtaClicked();
                    continueToDrawdown(0, drawdownOffer?.offer_id!);
                }}
            >
                <FormattedMessage
                    id="_.outstanding_view.dashboardActionPanel.extendInterestOnlyCTA"
                    defaultMessage="Extend my Interest-Only Period"
                />
            </Button>
            <ErrorBoundary fallback={() => <FallbackErrorModal />}>
                <Suspense
                    fallback={
                        <div
                            className="flex-1 rounded-m bg-structure-100 p-l shadow-black-s"
                            data-testId="loan-overview-loading"
                        >
                            <MainContentPending />
                        </div>
                    }
                >
                    <RepaymentScheduleSummary
                        topupDrawdownAmount={0}
                        accountId={accountId}
                    />
                </Suspense>
            </ErrorBoundary>
        </div>
    );
});
